var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcp-switch",class:{ open: _vm.isOpen},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }